<template>
  <b-card id="page-inventories" no-body class="mb-0 p-2">
    <b-card-header
      class="pl-0 pr-0 d-flex align-items-between justify-content-center"
    >
      <b-col cols="12" md="4">
        <b-card-title>
          <h2>{{ $t(label("title")) }}</h2>
        </b-card-title>
      </b-col>

      <b-col v-if="canCreate" cols="12" md="8" class="d-none d-md-table">
        <b-col cols="12" class="d-flex align-items-between justify-content-end">
          <b-button variant="outline-primary" class="mr-1" @click="onKardex">
            <feather-icon icon="ClipboardIcon" class="mr-25" size="18" />
            <span class="text-nowrap">{{ $t(label("kardex")) }}</span>
          </b-button>
          <b-button id="tooltip-create" variant="primary" @click="onCreate">
            <feather-icon icon="PlusIcon" class="mr-25" size="18" />
            <span class="text-nowrap">{{ $t(label("register")) }}</span>
          </b-button>
        </b-col>
      </b-col>

      <b-col
        cols="12"
        sm="12"
        md="8"
        class="d-md-none d-flex justify-content-end pt-2"
      >
        <b-button
          variant="outline-primary"
          class="btn-icon mr-1"
          @click="onKardex"
        >
          <feather-icon icon="ClipboardIcon" size="18" />
        </b-button>
        <b-button
          v-if="canCreate"
          id="tooltip-create"
          variant="primary"
          class="btn-icon"
          @click="onCreate"
        >
          <feather-icon icon="PlusIcon" size="18" />
        </b-button>
      </b-col>
    </b-card-header>

    <!-- <b-alert v-if="!companyGuid" show variant="warning">
      {{ $t(label("selectCompany")) }}
    </b-alert> -->

    <Filterss
      :fields="fildsToFilters"
      :model="model"
      @filter-applied="applyFilters"
      @filter-reset="resetFilters"
    />

    <div class="inventories-table-shell d-none d-md-block shadow-sm rounded">
      <b-table
        id="inventories-table"
        responsive
        table-class="inventories-data-table"
        :head-variant="headVariant"
        :striped="striped"
        :bordered="bordered"
        :borderless="borderless"
        :outlined="outlined"
        :per-page="perPage"
        :busy="loading"
        :items="items"
        :fields="fields"
      >
        <template #head()="data">
          <span class="text-black">{{
            $t(labelHeader(data.label.toLowerCase()))
          }}</span>
        </template>

        <template #cell(movementDate)="data">
          {{ formatDate(data.item.movementDate) }}
        </template>

        <template #cell(movementType)="data">
          {{ movementTypeText(data.item) }}
        </template>

        <template #cell(supplierName)="data">
          {{ data.item.supplierName || "-" }}
        </template>

        <template #cell(documentNumber)="data">
          {{ data.item.documentNumber || "-" }}
        </template>

        <template #cell(totalQuantity)="data">
          {{ data.item.totalQuantity || 0 }}
        </template>

        <template #cell(totalProducts)="data">
          {{ data.item.totalProducts || 0 }}
        </template>

        <template #cell(status)="data">
          <b-badge :variant="statusVariant(data.item.status)">
            {{ statusText(data.item.status) }}
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <div class="inventories-table-actions">
            <feather-icon
              v-if="canShow"
              class="text-success cursor-pointer"
              size="18"
              icon="FileTextIcon"
              @click="onShow(data.item.guid)"
            />
          </div>
        </template>

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle ml-50" />
            <strong>{{ $t("loading") }}...</strong>
          </div>
        </template>
      </b-table>
    </div>

    <div class="mx-2 d-none d-md-table">
      <b-row>
        <b-col cols="12" md="2" class="mb-2">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">
              {{ $t("perPage") }}
            </label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
              @change="handlePerPageChange"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="10"
          class="d-flex align-items-center justify-content-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
            first-number
            last-number
            @change="handlePageChange"
          >
            <template #prev-text>
              <feather-icon size="18" icon="ChevronLeftIcon" />
            </template>
            <template #next-text>
              <feather-icon size="18" icon="ChevronRightIcon" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>

    <div
      id="inventory-list-container"
      class="d-block d-md-none mt-1 list-container"
    >
      <b-list-group>
        <b-list-group-item
          v-for="item in items"
          :key="item.guid"
          class="d-flex flex-column align-items-start border border-primary rounded mb-1"
        >
          <div class="d-flex w-100 justify-content-between mb-1">
            <strong>{{ movementTypeText(item) }}</strong>
            <b-dropdown variant="link" no-caret toggle-class="p-0" right>
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" />
              </template>
              <b-dropdown-item v-if="canShow" @click="onShow(item.guid)">
                <feather-icon class="text-success mr-25" icon="FileTextIcon" />
                {{ $t("show") }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <span
            >{{ $t(labelHeader("date")) }}:
            {{ formatDate(item.movementDate) }}</span
          >
          <span
            >{{ $t(labelHeader("document")) }}:
            {{ item.documentNumber || "-" }}</span
          >
          <span
            >{{ $t(labelHeader("supplier")) }}:
            {{ item.supplierName || item.nameSupplier || "-" }}</span
          >
          <span
            >{{ $t(labelHeader("totalquantity")) }}:
            {{ item.totalQuantity || item.quantityTotal || 0 }}</span
          >
        </b-list-group-item>
        <b-list-group-item v-if="items.length === 0" class="text-center">
          {{ $t("notRegister") }}
        </b-list-group-item>
        <b-list-group-item v-if="loading">
          <b-spinner variant="success" />
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-card>
</template>

<script>
import _ from "lodash";
import {
  BAlert,
  BBadge,
  BButton,
  BCard,
  BCardHeader,
  BCardTitle,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormSelect,
  BListGroup,
  BListGroupItem,
  BPagination,
  BRow,
  BSpinner,
  BTable,
} from "bootstrap-vue";
import Filterss from "../components/filters/Filterss.vue";
import {
  allInventoryMovements,
  allMovementTypes,
} from "@core/api/request/inventories";
import { allSuppliers } from "@core/api/request/suppliers";
import { getParams } from "@core/utils/utils";
import { canAccess } from "@/security/permissions/permissionHelper";

export default {
  components: {
    BAlert,
    BBadge,
    BButton,
    BCard,
    BCardHeader,
    BCardTitle,
    BCol,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    BFormSelect,
    BListGroup,
    BListGroupItem,
    BPagination,
    BRow,
    BSpinner,
    BTable,
    Filterss,
  },
  data: () => ({
    model: "inventories",
    companyGuid: null,
    loading: false,
    totalRows: 0,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    hasNextPage: true,
    items: [],
    movementTypes: [],
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    appliedFilters: {},
    fields: [
      {
        label: "date",
        key: "movementDate",
        sortable: true,
        thClass: "inventories-col-date",
        tdClass: "inventories-col-date",
      },
      {
        label: "movementType",
        key: "movementTypeName",
        sortable: true,
        thClass: "inventories-col-movement-type",
        tdClass: "inventories-col-movement-type",
      },
      {
        label: "supplier",
        key: "supplierName",
        sortable: true,
        thClass: "inventories-col-supplier",
        tdClass: "inventories-col-supplier",
      },
      {
        label: "document",
        key: "documentNumber",
        sortable: true,
        thClass: "inventories-col-document",
        tdClass: "inventories-col-document",
      },
      {
        label: "description",
        key: "description",
        sortable: false,
        thClass: "inventories-col-description",
        tdClass: "inventories-col-description",
      },
      {
        label: "totalQuantity",
        key: "totalQuantity",
        sortable: false,
        thClass: "inventories-col-total-quantity",
        tdClass: "inventories-col-total-quantity",
      },
      {
        label: "totalProducts",
        key: "totalProducts",
        sortable: false,
        thClass: "inventories-col-total-products",
        tdClass: "inventories-col-total-products",
      },
      {
        label: "status",
        key: "status",
        sortable: true,
        thClass: "inventories-col-status",
        tdClass: "inventories-col-status",
      },
      {
        label: "action",
        key: "actions",
        sortable: false,
        thClass: "inventories-col-actions",
        tdClass: "inventories-col-actions",
      },
    ],
    fildsToFilters: [
      {
        name: "search",
        title: "search",
        placeholder: "search",
        type: "search",
        visible: true,
      },
      {
        name: "dateFrom",
        title: "dateFrom",
        placeholder: "dateFrom",
        type: "date",
        visible: true,
      },
      {
        name: "dateTo",
        title: "dateTo",
        placeholder: "dateTo",
        type: "date",
        visible: true,
      },
      {
        name: "movementTypeCode",
        title: "movementType",
        placeholder: "movementType",
        type: "select",
        options: [],
        visible: true,
        multiple: false,
        close: true,
      },
      {
        name: "idSupplier",
        title: "supplier",
        placeholder: "supplier",
        type: "select",
        options: [],
        visible: true,
        multiple: false,
        close: true,
      },
    ],
  }),
  computed: {
    canCreate() {
      return canAccess("inventories", "creation");
    },
    canShow() {
      return canAccess("inventories", "reading");
    },
  },
  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.resetLocalData();
      this.loadData();
    },
  },
  created() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.loadData();
  },
  mounted() {
    const listContainer = document.getElementById("inventory-list-container");
    if (listContainer) {
      listContainer.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    const listContainer = document.getElementById("inventory-list-container");
    if (listContainer) {
      listContainer.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    label(field) {
      return `pages.inventories.table.${field}`;
    },
    labelHeader(field) {
      return `pages.inventories.table.tableHeader.${field}`;
    },
    resetLocalData() {
      this.items = [];
      this.totalRows = 0;
      this.currentPage = 1;
      this.hasNextPage = true;
      this.appliedFilters = {};
    },
    normalizeArray(resp) {
      const data = _.get(resp, "data");
      return (
        data?.items ||
        data?.listOfItems?.items ||
        data?.data?.items ||
        (Array.isArray(data) ? data : [])
      );
    },
    async loadData() {
      if (!this.companyGuid) {
        this.items = [];
        this.totalRows = 0;
        return;
      }

      try {
        this.loading = true;
        const [movementsResp, movementTypesResp, suppliersResp] =
          await Promise.all([
            allInventoryMovements(this.chargeParams()),
            allMovementTypes(),
            allSuppliers(
              getParams([
                "page,1",
                "rows,999",
                `guidCompany,${this.companyGuid}`,
                "active,true",
              ]),
            ),
          ]);
        const movements = _.get(movementsResp, "data");
        this.items = movements.items || [];
        this.totalRows = movements?.totalRows || 0;
        this.hasNextPage = movements?.currentPage < movements?.totalPages || 0;

        this.movementTypes = this.normalizeArray(movementTypesResp);
        this.setFilterOptions(
          "movementTypeCode",
          this.movementTypes.map((item) => ({
            label: item.name || item.description || item.code,
            value: item.code || item.movementTypeCode,
          })),
        );

        this.setFilterOptions(
          "idSupplier",
          this.normalizeArray(suppliersResp).map((item) => ({
            label: item.name,
            value: item.idSupplier,
          })),
        );
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error loading inventory movements", error.message);
      } finally {
        this.loading = false;
      }
    },
    async loadDataInfinity() {
      if (!this.hasNextPage || !this.companyGuid) return;
      try {
        this.loading = true;
        const resp = await allInventoryMovements(this.chargeParams());
        const data = _.get(resp, "data", {});
        if (Array.isArray(data?.items)) {
          this.items = [...this.items, ...data.items];
        }
        this.totalRows = data?.totalRows || 0;
        this.hasNextPage = data?.currentPage < data?.totalPages || false;
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      } finally {
        this.loading = false;
      }
    },
    setFilterOptions(name, options) {
      this.fildsToFilters.forEach((field) => {
        if (field.name === name) {
          field.options = options;
        }
      });
    },
    chargeParams() {
      const arrParams = [
        `page,${this.currentPage}`,
        `rows,${this.perPage}`,
        `guidCompany,${this.companyGuid}`,
      ];

      Object.keys(this.appliedFilters).forEach((key) => {
        const value = this.appliedFilters[key];
        if (value !== null && value !== undefined && value !== "") {
          arrParams.push(`${key},${value}`);
        }
      });

      return getParams(arrParams);
    },
    async handleScroll() {
      const container = document.getElementById("inventory-list-container");
      if (
        container &&
        container.scrollTop + container.clientHeight >=
          container.scrollHeight - 1
      ) {
        this.currentPage++;
        await this.loadDataInfinity();
      }
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadData();
    },
    handlePerPageChange() {
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadData();
    },
    applyFilters(filters) {
      this.appliedFilters = filters || {};
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadData();
    },
    resetFilters() {
      this.appliedFilters = {};
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadData();
    },
    movementTypeText(item) {
      return (
        item.movementTypeName ||
        item.movementType ||
        item.movementTypeCode ||
        item.type ||
        "N/A"
      );
    },
    statusVariant(status) {
      if (!status) return "secondary";
      const normalized = String(status).toLowerCase();
      if (normalized.includes("cancel") || normalized.includes("error")) {
        return "danger";
      }
      if (normalized.includes("pending")) return "warning";
      return "success";
    },
    statusText(status) {
      if (!status) return "N/A";
      const translationKey = `pages.inventories.table.statuses.${String(
        status,
      )
        .trim()
        .toLowerCase()}`;
      return this.$te(translationKey) ? this.$t(translationKey) : status;
    },
    formatDate(value) {
      if (!value) return "-";
      return this.moment(value).isValid()
        ? this.moment(value).format("DD/MM/YYYY HH:mm")
        : value;
    },
    onCreate() {
      if (!this.canCreate) return;
      this.$router.push({
        name: "inventoryMovementCreate",
        params: { option: 1 },
      });
    },
    onShow(guid) {
      if (!this.canShow || !guid) return;
      this.$router.push({
        name: "inventoryMovementDetail",
        params: { option: 2, guid },
      });
    },
    onKardex() {
      if (!this.canShow) return;
      this.$router.push({ name: "inventoryKardex" });
    },
    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
  },
};
</script>

<style lang="scss">
.list-container {
  height: 60vh !important;
  overflow-y: auto;
}

#page-inventories {
  width: 100%;
  max-width: 100%;
  min-width: 0;

  .inventories-table-shell {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
  }

  .inventories-table-shell > .table-responsive {
    display: block;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow-x: auto;
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: auto;
    scrollbar-color: rgba(115, 103, 240, 0.55) rgba(115, 103, 240, 0.1);
  }

  .inventories-table-shell > .table-responsive::-webkit-scrollbar {
    height: 10px;
  }

  .inventories-table-shell > .table-responsive::-webkit-scrollbar-track {
    background: rgba(115, 103, 240, 0.08);
    border-radius: 5px;
  }

  .inventories-table-shell > .table-responsive::-webkit-scrollbar-thumb {
    background: rgba(115, 103, 240, 0.5);
    border: 2px solid rgba(255, 255, 255, 0.8);
    border-radius: 5px;
  }

  .inventories-table-shell > .table-responsive::-webkit-scrollbar-thumb:hover {
    background: rgba(115, 103, 240, 0.72);
  }

  .inventories-data-table {
    min-width: 1900px;
    margin-bottom: 0;
    table-layout: fixed;

    th,
    td {
      padding: 1rem 1.15rem;
      vertical-align: middle;
      word-break: normal;
      overflow-wrap: break-word;
    }

    thead th {
      white-space: nowrap;
    }

    tbody tr {
      transition: background-color 0.18s ease;
    }

    tbody tr:hover {
      background-color: rgba(115, 103, 240, 0.045);
    }

    .inventories-col-date {
      width: 190px;
      white-space: nowrap;
    }

    .inventories-col-movement-type {
      width: 230px;
    }

    .inventories-col-supplier {
      width: 240px;
    }

    .inventories-col-document {
      width: 180px;
      white-space: nowrap;
    }

    .inventories-col-description {
      width: 360px;
    }

    .inventories-col-total-quantity,
    .inventories-col-total-products {
      width: 170px;
      white-space: nowrap;
      text-align: center;
    }

    .inventories-col-status {
      width: 190px;
      white-space: nowrap;
      text-align: center;
    }

    .inventories-col-actions {
      position: sticky;
      right: 0;
      z-index: 2;
      width: 120px;
      min-width: 120px;
      background-color: #fff;
      box-shadow: -8px 0 12px -12px rgba(34, 41, 47, 0.45);
    }

    thead .inventories-col-actions {
      z-index: 3;
      background-color: #f3f2f7;
    }
  }

  .inventories-table-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.85rem;
    min-width: max-content;
  }
}
</style>
